<script lang="ts" setup>
import OmniTextarea from "@/components/omni/OmniTextarea.vue";

const model = defineModel<string>({ required: true });

const emit = defineEmits<{
  (e: "blur", value: string): void;
}>();

function onBlur() {
  emit("blur", model.value);
}
</script>

<template>
  <omni-textarea
    v-model="model"
    class="order-note pa-3 border-grey-lighter-1 bg-grey-lighten-5 rounded note-container"
    hide-close
    variant="plain"
    @blur="onBlur"
  />
</template>

<style lang="scss" scoped>
.note-container {
  min-height: 100px;
}

.order-note {
  :deep(.v-field__input) {
    padding: 0;
    margin: 0;
  }
}
</style>
